import { FC, Suspense } from "react";
import { StyledWrapper } from "@app/components/common/LoadingElement.styles";

import { LoadingElement } from "@app/components/common/LoadingElement";
import { useDataId } from "@dit/ui-core-hooks";

type Props = {
    loadingMessage?: string;
    size?: number;
    className?: string;
};

export const LoadingPage: FC<Props> = props => {
    const { getManualId } = useDataId(LoadingPage);

    return (
        <Suspense>
            <StyledWrapper data-id={getManualId("page-loader")}>
                <LoadingElement {...props} />
            </StyledWrapper>
        </Suspense>
    );
};
